<template>
  <AlertDialog :open="show">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Session Expired</AlertDialogTitle>
        <AlertDialogDescription>
          Your session has expired. Please sign in again to continue.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction @click="goToLogin">
          Sign in
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

const show = ref(false)

function onSessionExpired() {
  show.value = true
}

function goToLogin() {
  window.location.href = '/login?session_expired=1'
}

onMounted(() => {
  window.addEventListener('session-expired', onSessionExpired)
})

onUnmounted(() => {
  window.removeEventListener('session-expired', onSessionExpired)
})
</script>
